import styles from "../app.module.scss";
import { getTimeAgo } from "./utils";

type SmallNewsItem = {
  title: string;
  timestamp: Date;
  body: React.JSX.Element;
};

export const smallNews: SmallNewsItem[] = [
  {
    title: "Hostens arbetsdag",
    timestamp: new Date("2025-06-03T20:00:00"),
    body: (
      <p>
        Höstens arbetsdag 2025 blir den 26 oktober, vi har bestämt oss för att bara
        ha en dag istället för två som vanligt.
      </p>
    ),
  },
];

export const SmallNewsItem = ({ item, index }: { item: SmallNewsItem, index: number }) => {
  return (
    <div key={index}>
      <span className={styles.smallNewsTitle}>{item.title}</span>
      <span className={styles.smallGrey}>{getTimeAgo(item.timestamp)}</span>

      {item.body}
    </div>
  );
};
